// notificationReducer.js

import {
  CLEAR_NOTIFICATIONS,
  LOGOUT,
  SINGLE_NOTIFICATION_CLEAR,
  UPDATE_NOTIFICATIONS,
} from "./actions";

// Action Type

// Action Creator
export const updateNotifications = (notification) => {
  return {
    type: UPDATE_NOTIFICATIONS,
    payload: notification,
  };
};

// New action creator to clear notifications
export const clearNotifications = () => {
  return {
    type: CLEAR_NOTIFICATIONS,
  };
};

const initialState = {
  notifications: [],
};

export const clearSingleNotifications = (notificationId) => {
  return {
    type: SINGLE_NOTIFICATION_CLEAR,
    payload: notificationId,
  };
};

// SINGLE_NOTIFICATION_CLEAR

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_NOTIFICATIONS:
      return {
        ...state,
        notifications: [action.payload, ...state.notifications].slice(0, 50),
      };
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
      };
    case LOGOUT:
      return {
        ...state,
        notifications: [],
      };
    case SINGLE_NOTIFICATION_CLEAR:
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.id !== action.payload,
        ),
      };

    default:
      return state;
  }
};

export default notificationReducer;
